import { Component, OnInit, OnDestroy } from '@angular/core';
import { CartService } from 'src/app/services/cart.service';
import { Subscription } from 'rxjs';
import { MatDialog, MatSnackBar, MatDatepickerInputEvent } from '@angular/material';
import { ViewOrdersComponent } from './view-orders/view-orders.component';
import * as moment from 'moment';
import { OrdersService } from 'src/app/services/orders.service';
import { UserService } from 'src/app/services/user.service';
import { Router } from '@angular/router';
import { get } from 'scriptjs';
import { AddCreditCardComponent } from '../profile-settings/add-credit-card/add-credit-card.component';
import { CardService } from 'src/app/services/card.service';
import { DeliveriesService } from 'src/app/services/deliveries.service';

declare var $: any;
declare var WebxpayTokenizeInit: any;

import { LoginComponent } from '../auth/login/login.component';
import { MetaService } from 'src/app/services/meta.service';
import { VerifyMobileComponent } from '../auth/verify-mobile/verify-mobile.component';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.css']
})
export class CheckoutComponent implements OnInit, OnDestroy {
  // cards
  cards: any = [];
  cardsSub: Subscription;

  // checkout price
  price: number = 0;
  private priceSub: Subscription;

  // address
  addressSelected: boolean = false;

  // transaction type option
  transactionType = 'Credit Card';

  inCheckOut: boolean = false;
  checked;
  moment: any = moment;
  cardClicked = false;
  isLoading = false;
  isUserLoading = true;

  user: any = '';
  addressID: string = '';
  cardID: string = '';
  address = {
    houseNo: '',
    street: '',
    building: '',
    city: ''
  };

  // next address events
  nextDeliveryDates: any = [];
  isDateClicked: boolean = false;
  isDatesLoading: boolean = false;
  deliveryDateOne: string = '';
  deliveryDateTwo: any = '';
  deliveryDateThree: any = '';
  deliveryDateFour: any = '';
  // next address events ends

  totalObj = {
    total: 0,
    subtotal: 0,
    fees: [],
    oneDeliveryTotal: 0
  }

  minDate = new Date(+new Date() + 86400000);

  subscriptionType: string = '';
  couponFail: boolean = false;

  couponAdded: boolean = false;
  couponAddedSub: Subscription;

  deliveryDays = [];

  constructor(private cartService: CartService, private deliveryService: DeliveriesService, private ordersService: OrdersService, private userService: UserService, private META_DATA: MetaService, private dialog: MatDialog, private snackBar: MatSnackBar, private router: Router, private cardService: CardService) { }

  myFilter = (d: Date | null): boolean => {

    const day = (d || new Date()).getDay();
    const date = (d || new Date()).getDate();
    const todayDate = new Date().getDate();

    let days = this.deliveryDays;


    if (days.length == 1) {
      return day !== days[0] && date !== todayDate;
    }

    if (days.length == 2) {
      return day !== days[0] && day !== days[1] && date !== todayDate;
    }

    if (days.length == 3) {
      return day !== days[0] && day !== days[1] && day !== days[2] && date !== todayDate;
    }

    if (days.length == 4) {
      return day !== days[0] && day !== days[1] && day !== days[2] && day !== days[3] && date !== todayDate;
    }

    if (days.length == 5) {
      return day !== days[0] && day !== days[1] && day !== days[2] && day !== days[3] && day !== days[4] && date !== todayDate;
    }

    if (days.length == 6) {
      return day !== days[0] && day !== days[1] && day !== days[2] && day !== days[3] && day !== days[4] && day !== days[5] && date !== todayDate;
    }

    if (days.length == 7) {
      return day !== days[0] && day !== days[1] && day !== days[2] && day !== days[3] && day !== days[4] && day !== days[5] && day !== days[6] && date !== todayDate;
    }
  }

  subscriptionButtonSub: Subscription;

  ngOnInit() {
    this.paymentGateWay(); // paymentGateway function that is on the bottom is called

    // get user from lcoal storage
    const localUser = localStorage.getItem('user');
    let user = JSON.parse(localUser);

    if (user.userType !== 'User') {
      this.router.navigate(['/']);
      this.dialog.open(LoginComponent);
      this.snackBar.open('Please log in to view this page', 'Dismiss', {
        duration: 3000
      });
      return;
    }

    user.mobile = user.mobile.split('+94')[1];

    this.META_DATA.getMetaData().subscribe(result => {
      if (result.success) {
        this.deliveryDays = result.data.invalidDeliveryDays;
      }
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });

    this.userService.getMe().subscribe(result => {
      this.isUserLoading = false;
      result.data.mobile = result.data.mobile.split('+94')[1];
      this.user = result.data;
    }, error => {
      this.isUserLoading = false;
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });

    if (user.cards == '' || user.cards == undefined) {
      this.cards = [];
    } else {
      this.cards = user.cards;
    }
    // ends user info

    // price and total price is gotten
    const onloadData = this.cartService.onLoad();
    this.price = onloadData.price;
    this.totalObj = onloadData.totalObj;

    // subscription toggle
    const subscriptionType = localStorage.getItem('subscriptionType');
    this.subscriptionType = subscriptionType;

    if (subscriptionType == '') {
      this.checked = false;
    } else {
      if (this.subscriptionType == 'One Delivery') {
        this.checked = false;
      } else {
        this.checked = true;
      }
    }

    // subscribe to price subject
    this.priceSub = this.cartService.getPriceUpdated().subscribe(result => {
      this.price = result;
    });

    // subscribe to total object
    this.cartService.getTotalObjUpdated().subscribe(result => {
      this.totalObj = result;
    });

    this.cardsSub = this.cardService.getCards().subscribe(result => {
      this.cards = result;
    });

    this.subscriptionButtonSub = this.cartService.getSubscriptionButtonChanged().subscribe(result => {
      if (result) {
        this.checked = true;
        this.subscriptionType = 'Subscription'
        localStorage.setItem('subscriptionType', this.subscriptionType.toString());
      } else {
        this.checked = false;
        this.subscriptionType = 'One Delivery'
        localStorage.setItem('subscriptionType', this.subscriptionType.toString());
      }
      this.cartService.onSubscriptionTypeChange();
    });

    this.couponAddedSub = this.cartService.getCouponStatusUpdated().subscribe(result => {
      this.couponAdded = result;
    });
  }

  onSelectDeliveryDate(type: string, event: MatDatepickerInputEvent<Date>) {
    this.isDateClicked = true;
    this.isDatesLoading = true;
    const data = new FormData();
    data.append('deliveryDate', moment(event.value).format('DD-MM-YYYY'));

    this.deliveryService.getNextDeliveryDates(data).subscribe(result => {
      this.isDatesLoading = false;
      if (result.success) {
        result.data.map(date => {
          const splitDate = date.split('-');
          const newDate = `${splitDate[2]}-${splitDate[1]}-${splitDate[0]}`;
          this.nextDeliveryDates.push(newDate);
        });

        this.deliveryDateTwo = this.nextDeliveryDates[0];
        this.deliveryDateThree = this.nextDeliveryDates[1];
        this.deliveryDateFour = this.nextDeliveryDates[2];
      }
    }, error => {
      this.isDatesLoading = false;
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });
  }

  onRefreshDates() {
    const data = new FormData();
    data.append('deliveryDate', moment(this.deliveryDateOne).format('DD-MM-YYYY'));

    this.deliveryService.getNextDeliveryDates(data).subscribe(result => {
      if (result.success) {
        let nextDeliveryDates = [];

        result.data.map(date => {
          const splitDate = date.split('-');
          const newDate = `${splitDate[2]}-${splitDate[1]}-${splitDate[0]}`;
          nextDeliveryDates.push(newDate);
        });

        this.deliveryDateTwo = nextDeliveryDates[0];
        this.deliveryDateThree = nextDeliveryDates[1];
        this.deliveryDateFour = nextDeliveryDates[2];
      }
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });
  }

  onMonthlySubscription(event) {
    this.cartService.setSubscriptionButtonChange(event.checked);
    if (event.checked) {
      this.subscriptionType = 'Subscription'
      localStorage.setItem('subscriptionType', this.subscriptionType.toString());
    } else {
      this.subscriptionType = 'One Delivery'
      localStorage.setItem('subscriptionType', this.subscriptionType.toString());
    }
    this.cartService.onSubscriptionTypeChange();
  }

  onApplyCouponCode(CouponCode: string) {
    if (CouponCode == '') {
      this.snackBar.open('Coupon code is empty', 'Dismiss', {
        duration: 3000
      });
      return;
    }

    localStorage.setItem('coupon', CouponCode);
    this.cartService.onApplyCoupon();
  }

  onRemoveCouponCode() {
    localStorage.removeItem('coupon');
    this.cartService.onApplyCoupon();
    this.cartService.setCouponStatus(false);
  }

  onViewOrder() {
    this.dialog.open(ViewOrdersComponent, {
      width: '450px',
      maxHeight: '90vh'
    });
  }

  onAddressSelect(ID: string) {
    this.addressID = ID;
  }

  onSelectAddress(index, ID) {
    const addressArray = this.user.addresses
    for (let i = 0; i < addressArray.length; i++) {
      if (i === index) {
        if (addressArray[i].active == '' || addressArray[i].active == undefined || addressArray[i].active == false) {
          addressArray[i].active = true;
          this.addressSelected = true;
          this.addressID = ID;
          return;
        } else {
          this.addressSelected = false;
          addressArray[i].active = false;
          this.addressID = '';
          return;
        }
      } else {
        addressArray[i].active = false;
        this.addressSelected = false;
        this.addressID = '';
      }
    }
  }

  paymentDetail(index, ID) {
    const cardArray = this.cards
    for (let i = 0; i < cardArray.length; i++) {
      if (i === index) {
        if (cardArray[i].active == '' || cardArray[i].active == undefined || cardArray[i].active == false) {
          cardArray[i].active = true;
          this.cardClicked = true;
          this.cardID = ID;
        } else {
          this.cardClicked = false;
          cardArray[i].active = false;
          this.cardID = '';
        }
      } else {
        cardArray[i].active = false;
      }
    }
  }

  onCreateOrder() {
    this.isLoading = true;

    let order;

    const orderType = localStorage.getItem('subscriptionType');

    if (this.user.name == '') {
      this.snackBar.open('Contact person name cannot be empty', 'Dismiss', {
        duration: 3000
      });
      this.isLoading = false;
      return;
    }

    if (this.user.mobile == '') {
      this.snackBar.open('Contact person mobile cannot be empty', 'Dismiss', {
        duration: 3000
      });
      this.isLoading = false;
      return;
    }

    if (this.deliveryDateOne == '') {
      this.snackBar.open('Please select delivery date', 'Dismiss', {
        duration: 3000
      });
      this.isLoading = false;
      return;
    }

    let deliveryDates;
    if (orderType == 'Subscription') {
      deliveryDates = [moment(this.deliveryDateOne).format('DD-MM-YYYY'), moment(this.deliveryDateTwo).format('DD-MM-YYYY'), moment(this.deliveryDateThree).format('DD-MM-YYYY'), moment(this.deliveryDateFour).format('DD-MM-YYYY')];
    } else {
      deliveryDates = [moment(this.deliveryDateOne).format('DD-MM-YYYY')];
    }

    if (this.transactionType === 'Cash on Delivery' && !this.addressSelected) {

      if (this.address.houseNo == '' && this.address.street == '' && this.address.city == '') {
        this.snackBar.open('Please enter your address or a select an existing address', 'Dismiss', {
          duration: 3000
        });
        this.isLoading = false;
        return;
      }

      if (this.address.houseNo == '') {
        this.snackBar.open('House No. cannot be empty', 'Dismiss', {
          duration: 3000
        });
        this.isLoading = false;
        return;
      }

      if (this.address.street == '') {
        this.snackBar.open('Street cannot be empty', 'Dismiss', {
          duration: 3000
        });
        this.isLoading = false;
        return;
      }

      if (this.address.city == '') {
        this.snackBar.open('City cannot be empty', 'Dismiss', {
          duration: 3000
        });
        this.isLoading = false;
        return;
      }

      const address = {
        contactPerson: this.user.name,
        mobile: `+94${this.user.mobile}`,
        houseNo: this.address.houseNo,
        building: this.address.building || '--',
        street: this.address.street,
        city: this.address.city
      }

      order = this.getOrder(orderType, this.transactionType, deliveryDates, address, '', this.getBaskets(), this.getProducts());
    } else if (this.transactionType === 'Cash on Delivery' && this.addressSelected) {
      order = this.getOrder(orderType, this.transactionType, deliveryDates, this.addressID, this.cardID, this.getBaskets(), this.getProducts());
    } else if (this.transactionType === 'Credit Card' && !this.addressSelected) {

      if (!this.cardClicked) {
        this.snackBar.open('Please select a card', 'Dismiss', {
          duration: 3000
        });
        this.isLoading = false;
        return;
      }

      const address = {
        contactPerson: this.user.name,
        mobile: `+94${this.user.mobile}`,
        houseNo: this.address.houseNo,
        building: this.address.building || '--',
        street: this.address.street,
        city: this.address.city
      }
      order = this.getOrder(orderType, this.transactionType, deliveryDates, address, this.cardID, this.getBaskets(), this.getProducts());
    } else if (this.transactionType === 'Credit Card' && this.addressSelected) {
      if (!this.cardClicked) {
        this.snackBar.open('Please select a card', 'Dismiss', {
          duration: 3000
        });
        this.isLoading = false;
        return;
      }
      order = this.getOrder(orderType, this.transactionType, deliveryDates, this.addressID, this.cardID, this.getBaskets(), this.getProducts());
    }

    if (this.addressSelected && (this.address.houseNo !== '' || this.address.building !== '' || this.address.street !== '' || this.address.city !== '')) {
      this.snackBar.open('You cannot have both an existing address and a new address to be entered', 'Dismiss', {
        duration: 3000
      });
      this.isLoading = false;
      return;
    }

    if (!this.addressSelected && (this.address.houseNo == '' || this.address.street == '' || this.address.city == '')) {
      this.snackBar.open('Please enter a new address or a select an existing address.', 'Dismiss', {
        duration: 3000
      });
      this.isLoading = false;
      return;
    }

    this.ordersService.createOrder(order).subscribe(result => {
      if (result.success) {
        this.isLoading = false;
        this.router.navigate(['/profile']);
        this.cartService.setSubscriptionButtonChange(false);
        this.snackBar.open('Order successfully placed', 'Dismiss', {
          duration: 3000
        });
      }
      this.cartService.removeAll();
      localStorage.removeItem('coupon')
    }, error => {
      if (error.error.data.verified == false) {
        this.isLoading = false;
        this.dialog.open(VerifyMobileComponent, {
          maxWidth: '300px',
          data: {
            message: 'We have sent you a text message with the verification code. Please enter it and click verify to proceed.'
          }
        })
        this.snackBar.open(error.error.data.message, 'Dismiss', {
          duration: 3000
        });
      } else {
        this.isLoading = false;
        this.snackBar.open(error.error.data, 'Dismiss', {
          duration: 3000
        });
      }
    });
  }

  getOrder(OrderType, TransactionType, DeliveryDates, Address, Card, Baskets, Products) {
    const data = new FormData();

    data.append('orderType', OrderType);
    data.append('transactionType', TransactionType);
    data.append('deliveryDates', JSON.stringify(DeliveryDates));

    if (typeof Address == 'string') {
      data.append('addressID', Address);
    } else if (typeof Address == 'object') {
      data.append('address', JSON.stringify(Address));
    }

    if (Card != '') {
      data.append('card', Card);
    }

    data.append('baskets', JSON.stringify(Baskets));
    data.append('products', JSON.stringify(Products));

    const coupon = localStorage.getItem('coupon');
    if (coupon != null) {
      data.append('couponCode', coupon);
    }

    return data;
  }

  onSelectTransactionType(event) {
    if (event.value == 1) {
      this.transactionType = 'Credit Card';
      this.cardClicked = false;
      this.paymentGateWay();
    } else if (event.value == 2) {
      this.cardClicked = false;
      this.transactionType = 'Cash on Delivery'
    }
  }

  onEnableCardField() {
    this.cardClicked = false;
    this.paymentGateWay();
  }

  onAddCreditCard() {
    this.dialog.open(AddCreditCardComponent);
  }

  getBaskets() {
    const localBaskets = localStorage.getItem('baskets');
    const basketsJSON = JSON.parse(localBaskets) || [];
    let baskets = [];

    if (basketsJSON.length !== 0) {
      basketsJSON.map(basket => {
        const data = {
          _id: basket._id,
          quantity: basket.quantity
        }
        baskets.push(data);
      });
    }

    return baskets;
  }

  getProducts() {
    // get leaves
    const localLeaves = localStorage.getItem('leaves');
    const leavesJSON = JSON.parse(localLeaves) || [];
    let leaves = [];

    if (leavesJSON.length !== 0) {
      leavesJSON.map(leave => {
        const data = {
          _id: leave._id,
          quantity: leave.quantity
        }
        leaves.push(data);
      });
    }

    // get dressings
    const localDressings = localStorage.getItem('dressings');
    const dressingsJSON = JSON.parse(localDressings) || [];
    let dressings = [];

    if (dressingsJSON.length !== 0) {
      dressingsJSON.map(dressing => {
        const data = {
          _id: dressing._id,
          quantity: dressing.quantity
        }
        dressings.push(data);
      });
    }

    // combine products and dressings to create products
    const products = leaves.concat(dressings);
    return products;
  }

  paymentGateWay() {
    // TESTWEBXPATOKLKR
    get("https://cbcmpgs.gateway.mastercard.com/form/version/63/merchant/WEBXPATOKLKR/session.js", () => {
      // webxpay codes
      // init webxpay
      WebxpayTokenizeInit({
        card: {
          number: "#card-number",
          securityCode: "#security-code",
          expiryMonth: "#expiry-month",
          expiryYear: "#expiry-year",
          nameOnCard: "#cardholder-name",
        },
        ready: afterInit,
      });

      function afterInit(GenerateSession) {
        // save card
        $('#save-card-button').click(function () {
          $('#save-card-button').attr('disabled', true);

          GenerateSession(
            function (session) {
              handleSuccess(session);
            },
            function (error) {
              handleErrors(error);
            }
          );
        });
      }

      // execute when hosted session successfully generated
      function handleSuccess(sessionId) {
        $('#save-card-button').removeAttr('disabled');
        $('#save-card-button').html('Save');
      }

      // execute when hosted session generation fail.
      function handleErrors(error) {
        $('#save-card-button').removeAttr('disabled');
        $('#save-card-button').html('Save');

        $('.err').html('');
        $('.general-error').html('');

        switch (error.type) {
          case 'fields_in_error': {
            if (error.details.cardNumber) {
              if (error.details.cardNumber == 'missing') {
                $('.card-number-error').html('Enter valid card number');
              }
              if (error.details.cardNumber == 'invalid') {
                $('.card-number-error').html('Invalid card number');
              }
            }
            if (error.details.expiryMonth) {
              if (error.details.expiryMonth == 'missing') {
                $('.exp-month-error').html('Enter expiration month');
              }
              if (error.details.expiryMonth == 'invalid') {
                $('.exp-month-error').html('Invalid expiration month');
              }
            }
            if (error.details.expiryYear) {
              if (error.details.expiryYear == 'missing') {
                $('.exp-year-error').html('Enter expiration year');
              }
              if (error.details.expiryYear == 'invalid') {
                $('.exp-year-error').html('Invalid expiration year');
              }
            }
            if (error.details.securityCode) {
              if (error.details.securityCode == 'missing') {
                $('.cvv-error').html('Enter CVV');
              }
              if (error.details.securityCode == 'invalid') {
                $('.cvv-error').html('Invalid CVV');
              }
            }
            console.error('missing card details', error.details);
            break;
          }
          case 'request_timeout': {
            $('.general-error').html('<span class="text-decoration-uppercase">' + error.details + '</span>')
            console.error('request time out', error.details);
            break;
          }
          case 'system_error': {
            if (error.details == 'cvv missing') {
              $('.general-error').html('Enter CVV details');
            } else {
              $('.general-error').html(error.details);
            }
            console.error('system error', error.details);
            break;
          }
        }
      }
    });
  }

  ngOnDestroy() {
    // get user from lcoal storage
    const localUser = localStorage.getItem('user');
    let user = JSON.parse(localUser);

    if (user == null) {
      return;
    } else {
      if (user.userType !== 'User') {
        return;
      } else {
        this.cardsSub.unsubscribe();
        this.priceSub.unsubscribe();
        this.subscriptionButtonSub.unsubscribe();
        this.couponAddedSub.unsubscribe();
      }
    }
  }
}